import React from "react";

import "./style.css";

export default function LogoutMessage() {
  return (
    <div className="logout-page">
      <h1 style={{ color: "#0d5c63" }}>See you soon!</h1>
    </div>
  );
}
